export default "__VITE_ASSET__Bg4HeFKU__"